export const DEFAULT_LANGUAGE_ID = 'en';
export const DEFAULT_REION_ID = 'US';
export const DEFAULT_VOICE_ID = 'en-US-Wavenet-D';
export const DEFAULT_VOICE_NAME = 'Alan';